<template>
  <create-account-layout
    :current-step="1"
    :title="
      currentStep === CarrierTypeStep.CarrierType
        ? 'Carrier Type'
        : 'Claim your Carrier'
    "
  >
    <div class="mt-3">
      <section v-if="currentStep === CarrierTypeStep.CarrierType">
        <p class="text-md mb-6 mt-6 text-left text-dark-gray">
          Select the type of carrier that best describes your company.
        </p>
        <div class="mt-6">
          <!-- <flat-radio-buttons :options="carrierTypes" @selected="onTypeSelected" :selected="selectedCarrierType" /> -->
          <label
            class="mb-1 block text-left text-xxs font-bold uppercase text-dark-gray"
            for="intra_identifier"
            >type</label
          >
          <dropdown
            :options="typesOptions"
            :default="selectedCarrierType"
            name="types"
            placeholder="Select Type"
            :exclude-selected="true"
            class="text-xs"
            @dropdown-input="onTypeSelected"
          />
        </div>
        <div
          v-if="!isLoading"
          class="mt-2"
        >
          <div v-if="selectedCarrierType === CarrierTypes.Canadian">
            <label
              class="block text-left text-xs text-xxs font-bold uppercase text-dark-gray"
              for="intra_identifier"
              >identifier</label
            >
            <div class="mt-1">
              <dropdown
                :options="canadianAuthorities"
                :default="canadianData?.selectedAuthority?.id"
                name="canada_region"
                placeholder="Select Identifier Type"
                :exclude-selected="true"
                class="text-xs"
                @dropdown-input="onSelectCanadianAuthority"
              />
            </div>
            <div class="my-4">
              <dropdown
                :options="canadianData?.selectedAuthority?.entities ?? []"
                :default="canadianData?.selectedAuthority?.selectedEntity?.id"
                :disabled="
                  !canadianData?.selectedAuthority ||
                  canadianData?.selectedAuthority?.entities?.length <= 1
                "
                name="state"
                placeholder="Select Province or Territory"
                :exclude-selected="true"
                class="text-xs"
                @dropdown-input="onSelectCanadianEntity"
              />
            </div>
            <div class="mt-2 flex items-center">
              <div
                v-show="canadianData?.selectedAuthority?.showRegional"
                class="mr-2 w-32"
              >
                <flat-radio-buttons
                  :options="canadianIdentifierTypes"
                  :selected="String(canadianData?.identifierType)"
                  @selected="onCanadianTypeSelected"
                />
              </div>
              <div class="flex-1">
                <input
                  v-if="canadianData?.selectedAuthority?.selectedEntity?.format"
                  v-model="canadianData.identifier"
                  v-mask="
                    canadianData?.selectedAuthority?.selectedEntity?.format ??
                    ''
                  "
                  :disabled="!canadianData?.selectedAuthority?.selectedEntity"
                  class="gray-10 w-full rounded border border-transparent bg-off-white px-4 py-4 text-1md text-xs focus:bg-white focus:text-dark-gray"
                  type="text"
                  :placeholder="`Enter as ${canadianData?.selectedAuthority?.selectedEntity?.format}`"
                  name="canada_identifier"
                />
                <input
                  v-else
                  v-model="canadianData.identifier"
                  :disabled="!canadianData?.selectedAuthority?.selectedEntity"
                  class="gray-10 w-full rounded border border-transparent bg-off-white px-4 py-4 text-1md text-xs focus:bg-white focus:text-dark-gray"
                  type="text"
                  placeholder="Enter #"
                  name="canada_identifier"
                />
              </div>
            </div>
          </div>
          <div v-if="selectedCarrierType === CarrierTypes.IntraState">
            <div class="my-4">
              <dropdown
                label="SELECT STATE"
                :options="instraStateStates"
                :default="intraStateData?.selectedState"
                name="state"
                :exclude-selected="true"
                class="text-xs"
                @dropdown-input="onSelectIntraStateState"
              />
            </div>
            <div>
              <label
                class="mb-1 block text-left text-xxs font-bold uppercase text-dark-gray"
                for="intra_identifier"
                >Identifier</label
              >
              <input
                v-model="intraStateData.identifier"
                v-mask="'###-#################'"
                class="text-1mb gray-10 w-full rounded border border-transparent bg-off-white px-4 py-4 text-xs focus:bg-white focus:text-dark-gray"
                type="text"
                placeholder="Enter identifier #"
                name="intra_identifier"
              />
            </div>
          </div>
          <div v-if="selectedCarrierType === CarrierTypes.Mexican">
            <label
              class="my-4 mb-1 block text-left text-xs text-xxs font-bold uppercase text-dark-gray"
              for="intra_identifier"
              >RFC (Registro federal de contribuyentes)</label
            >
            <input
              v-model="mexicanData.rfc"
              v-mask="'XXX-XXXXXXXXXX'"
              class="gray-10 w-full rounded border border-transparent bg-off-white px-4 py-4 text-1md text-xs focus:bg-white focus:text-dark-gray"
              type="text"
              placeholder="Enter 12-13 digit RFC"
              name="mex_rfc"
            />
          </div>
          <div v-if="selectedCarrierType === CarrierTypes.European">
            <label
              class="block text-left text-xs text-xxs font-bold uppercase text-dark-gray"
              for="euro_identifier"
              >Identifier</label
            >
            <div class="mt-1">
              <dropdown
                :options="europeanIdentifierTypes"
                :default="europeanIdentifierTypes?.[0]?.id"
                :disabled="europeanIdentifierTypes?.length == 1"
                name="euro_identifier_type"
                placeholder="Select Identifier Type"
                :exclude-selected="true"
                class="text-xs"
                @dropdown-input="onSelectEuropeanIdentifierType"
              />
            </div>
            <div class="my-4">
              <dropdown
                :options="europeanCountries"
                :disabled="!europeanData?.selectedIdentifierType"
                name="euro_country"
                placeholder="Select Country"
                :exclude-selected="true"
                class="text-xs"
                @dropdown-input="onSelectEuropeanCountry"
              />
            </div>
            <div class="mt-2 flex items-center">
              <!-- <div
                class="w-32 mr-2"
                v-show="europeanData?.selectedAuthority?.showRegional"
              >
                <flat-radio-buttons
                  :options="europeanIdentifierTypes"
                  @selected="onEuropeanTypeSelected"
                  :selected="String(europeanData?.identifierType)"
                />
              </div> -->
              <div class="flex-1">
                <input
                  v-if="europeanData?.selectedCountry?.format"
                  v-model="europeanData.identifier"
                  v-mask="europeanData?.selectedCountry?.format ?? ''"
                  :disabled="!europeanData?.selectedCountry"
                  class="gray-10 w-full rounded border border-transparent bg-off-white px-4 py-4 text-1md text-xs focus:bg-white focus:text-dark-gray"
                  type="text"
                  :placeholder="`Enter as ${
                    europeanData?.selectedCountry?.format_placeholder ??
                    europeanData?.selectedCountry?.format
                  }`"
                  name="euro_identifier"
                />
                <input
                  v-else
                  v-model="europeanData.identifier"
                  :disabled="!europeanData?.selectedCountry"
                  class="gray-10 w-full rounded border border-transparent bg-off-white px-4 py-4 text-1md text-xs focus:bg-white focus:text-dark-gray"
                  type="text"
                  placeholder="Enter #"
                  name="euro_identifier"
                />
              </div>
            </div>
          </div>
        </div>
        <section v-if="selected_carrier">
          <h2 class="mt-6 text-left text-xl text-dark-blue">Your Company</h2>
          <div
            class="my-4 grid grid-cols-12 gap-1 rounded-md border-2 border-yellow-500 p-4 shadow-lg"
          >
            <div class="col-span-12 text-left text-dark-gray">
              {{ selected_carrier?.legal_name }}
            </div>
            <div class="col-span-6 text-left text-body-color">
              {{ identifiers }}
            </div>
          </div>
        </section>
      </section>
      <section v-else-if="currentStep === CarrierTypeStep.CarrierName">
        <p class="text-md mb-6 mt-6 text-left text-dark-gray">
          Let’s get some basic information to complete your account.
        </p>
        <div>
          <form-field
            label="Legal Name of Carrier"
            :value="legalName"
            class="text-xs"
            placeholder="Enter carrier's legal name"
            :on-input="handleLegalnameUpdate"
            name="full_name"
          />
        </div>
        <div class="mt-6">
          <form-field
            label="DBA Name of Carrier (Optional)"
            :value="dbaName"
            class="text-xs"
            placeholder="Enter carrier's DBA name"
            :on-input="handleDbaUpdate"
            name="dba_name"
          />
        </div>
      </section>
    </div>
    <button-main
      class="my-5"
      :disabled="!isContinueEnabled()"
      :is-loading="isSearching"
      value="Continue"
      @click="handleContinue"
    >
      <span class="text-1md">{{ getButtonText() }}</span>
    </button-main>
  </create-account-layout>
</template>

<script>
import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
import ButtonMain from '@/components/Button.vue';
import FlatRadioButtons from '@/components/FlatRadioButtons.vue';
import Dropdown from '@/components/Dropdown.vue';
import FormField from '@/components/FormField.vue';
import { toastResponse } from '@/common/handleServerResponse';

const CarrierTypes = {
  Canadian: 'canadian',
  IntraState: 'intrastate',
  Mexican: 'RFC',
  European: 'european',
};

const CanadianTypes = {
  Regional: 'R',
  National: 'N',
};

const CarrierTypeStep = {
  CarrierType: 0,
  CarrierName: 1,
};

export default {
  name: 'CarrierType',
  components: {
    CreateAccountLayout,
    ButtonMain,
    FlatRadioButtons,
    Dropdown,
    FormField,
  },
  data: function () {
    return {
      isLoading: false,
      legalName: '',
      dbaName: '',
      carrierTypes: [
        {
          id: CarrierTypes.Canadian,
          label: 'Canadian',
        },
        {
          id: CarrierTypes.IntraState,
          label: 'Intrastate',
        },
      ],
      selectedCarrierType: '',
      currentStep: CarrierTypeStep.CarrierType,
      CarrierTypeStep,
      CarrierTypes,
      intraStateStates: [],
      testText: '',
      canadianIdentifiers: [],
      intraStateData: {
        selectedState: '',
        identifier: '',
      },
      canadianIdentifierTypes: [
        {
          id: CanadianTypes.Regional,
          label: 'R',
        },
        {
          id: CanadianTypes.National,
          label: 'N',
        },
      ],
      mexicanData: {
        rfc: '',
      },
      typesOptions: [
        {
          label: 'Intrastate',
          parragraph: 'Hauling within a single US state only',
          id: CarrierTypes.IntraState,
        },
        {
          label: 'Intra-Canada',
          parragraph: 'Hauling within Canada only',
          id: CarrierTypes.Canadian,
        },
        {
          label: 'Intra-Mexico',
          parragraph: 'Hauling within Mexico only',
          id: CarrierTypes.Mexican,
        },
        {
          label: 'Intra-Europe',
          parragraph: 'Hauling within Europe only',
          id: CarrierTypes.European,
        },
      ],
      canadianAuthorities: [
        {
          label: 'National Safety Code (NSC)',
          id: 'NSC',
          entities: [],
          selectedEntity: undefined,
        },
        {
          label: 'Comm. Vehicle Operator’s Reg. (CVOR)',
          id: 'CVOR',
          entities: [],
          selectedEntity: undefined,
        },
        {
          label: 'Reg. Identification Number (NIR)',
          id: 'NIR',
          entities: [],
          selectedEntity: undefined,
          showRegional: true,
        },
      ],
      canadianData: {
        identifierType: CanadianTypes.Regional,
        identifier: '',
        selectedAuthority: undefined,
      },
      canadian_entities: {
        CVOR_ON: "Commercial Vehicle Operator's Registration - Ontario",
        NIR_QC: 'National Inventory Report - Quebec',
        NSC_AB: 'National Safety Code - Alberta',
        NSC_BC: 'National Safety Code - British Columbia',
        NSC_MB: 'National Safety Code - Manitoba',
        NSC_NB: 'National Safety Code - New Brunswick',
        NSC_NF: 'National Safety Code - Newfoundland',
        NSC_NT: 'National Safety Code - Northwest Territories',
        NSC_NS: 'National Safety Code - Nova Scotia',
        NSC_NU: 'National Safety Code - Nunavut',
        NSC_PE: 'National Safety Code - Prince Edward Island',
        NSC_SK: 'National Safety Code - Saskatchewan',
        NSC_YT: 'National Safety Code - Yukon Territory',
      },
      entities_formatting: {
        CVOR_ON: { format: '###-###-###', digits: 9 },
        NIR_QC: { format: '######-#', digits: 7 },
        NSC_AB: { format: '###-####', digits: 7 },
        NSC_BC: { format: '###-###-###', digits: 9 },
        NSC_MB: { format: '#######', digits: (n) => n >= 6 && n <= 7 },
        NSC_NB: { format: '#######', digits: 7 },
        NSC_NF: '',
        NSC_NT: '',
        NSC_NS: { format: '#########', digits: 9 },
        NSC_NU: '',
        NSC_PE: '',
        NSC_SK: { format: '#######', digits: 7 },
        NSC_YT: '',
      },
      non_urs_instrastate: {
        AR: 'Arkansas',
        IL: 'Illinois',
        LA: 'Louisiana',
        MS: 'Mississippi',
        NH: 'New Hampshire',
        NM: 'New Mexico',
        ND: 'North Dakota',
        RI: 'Rhode Island',
        SD: 'South Dakota',
        TN: 'Tennessee',
        VT: 'Vermont',
        VA: 'Virginia',
      },
      euro_vat_entities: {
        VAT_AT: 'Austria',
        VAT_BY: 'Belarus',
        VAT_BE: 'Belgium',
        VAT_BG: 'Bulgaria',
        VAT_HR: 'Croatia',
        VAT_CY: 'Cyprus',
        VAT_CZ: 'Czech Republic',
        VAT_DK: 'Denmark',
        VAT_EE: 'Estonia',
        VAT_FI: 'Finland',
        VAT_FR: 'France',
        VAT_DE: 'Germany',
        VAT_EL: 'Greece',
        VAT_HU: 'Hungary',
        VAT_IE: 'Ireland',
        VAT_IT: 'Italy',
        VAT_LV: 'Latvia',
        VAT_LT: 'Lithuania',
        VAT_LU: 'Luxembourg',
        VAT_MT: 'Malta',
        VAT_MD: 'Moldova',
        VAT_NL: 'Netherlands',
        VAT_PL: 'Poland',
        VAT_PT: 'Portugal',
        VAT_RO: 'Romania',
        VAT_RS: 'Serbia',
        VAT_SK: 'Slovakia',
        VAT_SI: 'Slovenia',
        VAT_ES: 'Spain',
        VAT_SE: 'Sweden',
        VAT_CH: 'Switzerland',
        VAT_UA: 'Ukraine',
        VAT_GB: 'United Kingdom',

        // Omitting these for now

        // VAT_AL: "Albania",
        // VAT_BA: "Bosnia and Herzegovina",
        // VAT_IS: "Iceland",
        // VAT_IL: "Israel",
        // VAT_KZ: "Kazakhstan",
        // VAT_MK: "North Macedonia",
        // VAT_NO: "Norway",
        // VAT_SM: "San Marino",
        // VAT_TR: "Turkey",
        // VAT_UZ: "Uzbekistan",

        // VAT_AU: "Australia",
        // VAT_CA: "Canada",
        // VAT_IN: "India",
        // VAT_ID: "Indonesia",
        // VAT_JP: "Japan",
        // VAT_NZ: "New Zealand",
        // VAT_NG: "Nigeria",
        // VAT_PH: "Philippines",
        // VAT_RU: "Russia",
        // VAT_SA: "Saudi Arabia",
        // VAT_TW: "Taiwan",
      },
      euro_vat_entities_formatting: {
        VAT_AT: {
          format_placeholder: '"ATU" + 8 digits',
          format: 'XXX########',
          digits: 11,
        },
        VAT_BY: {
          format_placeholder: '9 digits',
          format: '#########',
          digits: 9,
        },
        VAT_BE: {
          format_placeholder: '"BE" + 10 digits',
          format: 'XX##########',
          digits: 12,
        },
        VAT_BG: {
          format_placeholder: '9 or 10 digits',
          format: '##########',
          digits: (n) => n >= 9 && n <= 10,
        },
        VAT_HR: {
          format_placeholder: '"HR" + 11 digits',
          format: 'XX###########',
          digits: 13,
        },
        VAT_CY: {
          format_placeholder: '"CY" + 9 characters',
          format: 'XXXXXXXXXXX',
          digits: 11,
        },
        VAT_CZ: {
          format_placeholder: '"CZ" + 8-10 digits',
          format: 'XX##########',
          digits: (n) => n >= 10 && n <= 12,
        },
        VAT_DK: {
          format_placeholder: '"DK" + 8 digits',
          format: 'XX########',
          digits: 10,
        },
        VAT_EE: {
          format_placeholder: '9 digits',
          format: '#########',
          digits: 9,
        },
        VAT_FI: {
          format_placeholder: '"FI" + 8 digits',
          format: 'XX########',
          digits: 10,
        },
        VAT_FR: {
          // Characters 3 and 4 here can be letters, the rest are digits
          format_placeholder: '"FR" + 11 characters',
          format: 'XXXX#########',
          digits: 13,
        },
        VAT_DE: {
          format_placeholder: '"DE" + 9 digits',
          format: 'XX#########',
          digits: 11,
        },
        VAT_EL: {
          format_placeholder: '"EL" + 9 digits',
          format: 'XX#########',
          digits: 11,
        },
        VAT_HU: {
          format_placeholder: '"HU" + 8 digits',
          format: 'XX########',
          digits: 10,
        },
        VAT_IE: {
          // Another weird one, can have letters at certain positions
          format_placeholder: '"IE" + 7 digits + 1-2 characters',
          format: 'XX#X#####XX',
          digits: (n) => n >= 10 && n <= 11,
        },
        VAT_IT: {
          format_placeholder: '11 digits',
          format: '###########',
          digits: 11,
        },
        VAT_LV: {
          format_placeholder: '11 digits',
          format: '###########',
          digits: 11,
        },
        VAT_LT: {
          format_placeholder: '9 or 12 digits',
          format: '############',
          digits: (n) => n == 9 || n == 12,
        },
        VAT_LU: {
          format_placeholder: '8 digits',
          format: '########',
          digits: 8,
        },
        VAT_MT: {
          format_placeholder: '8 digits',
          format: '########',
          digits: 8,
        },
        VAT_MD: {
          format_placeholder: '7 digits',
          format: '#######',
          digits: 7,
        },
        VAT_NL: {
          format_placeholder: '"NL" + 9 digits + "B" + 2 digits',
          format: 'XX#########B##',
          digits: 14,
        },
        VAT_PL: {
          format_placeholder: '10 digits',
          format: '###-##-##-###',
          digits: 10,
        },
        VAT_PT: {
          format_placeholder: '9 digits',
          format: '#########',
          digits: 9,
        },
        VAT_RO: {
          format_placeholder: '"RO" + 2-10 digits',
          format: 'XX##########',
          digits: (n) => n >= 4 && n <= 12,
        },
        VAT_RS: {
          format_placeholder: '9 digits',
          format: '#########',
          digits: 9,
        },
        VAT_SK: {
          format_placeholder: '"SK" + 10 digits',
          format: 'XX##########',
          digits: 12,
        },
        VAT_SI: {
          format_placeholder: '"SI" + 8 digits',
          format: 'XX########',
          digits: 10,
        },
        VAT_ES: {
          // Another weird one
          format_placeholder: '"ES" + 9 characters',
          format: 'XXX#######X',
          digits: 11,
        },
        VAT_SE: {
          // Unclear whether "SE" prefix required or not
          format_placeholder: '"SE" + 12 digits',
          format: 'XX############',
          digits: 14,
        },
        VAT_CH: {
          // this one's a bit weird, may need to include 3-4 char code after 9-digit option
          // see https://en.wikipedia.org/wiki/VAT_identification_number
          format_placeholder: '6 or 9 digits',
          format: '#########',
          digits: (n) => n == 6 || n == 9,
        },
        VAT_UA: {
          format_placeholder: '12 digits',
          format: '############',
          digits: 12,
        },
        VAT_GB: {
          format_placeholder: '"GB" + 9 or 12 digits',
          format: 'XX############',
          digits: (n) => n == 11 || n == 14,
        },
      },
      europeanIdentifierTypes: [
        {
          label: 'Value-Added Tax ID Number (VAT)',
          id: 'VAT',
          entities: [],
          selectedEntity: undefined,
        },
      ],
      europeanCountries: [],
      europeanData: {
        selectedIdentifierType: undefined,
        selectedCountry: undefined,
        identifier: '',
      },
      iso_correct: {
        el: 'gr',
      },
      selected_carrier: undefined,
      isSearching: false,
    };
  },
  computed: {
    identifiers() {
      if (!this.selected_carrier?.identifiers) {
        return '';
      }

      const allowedIdentifiers = Object.keys(this.non_urs_instrastate)
        .concat(Object.keys(this.canadian_entities))
        .concat(Object.keys(this.euro_vat_entities));

      const identifiersList = this.selected_carrier.identifiers
        .filter((identifier) => allowedIdentifiers.includes(identifier.is_type))
        .map((identifier) => `${identifier.is_type}# ${identifier.value}`);

      return identifiersList?.join(' - ') ?? '';
    },
  },
  watch: {
    'canadianData.identifier': function () {
      this.selected_carrier = undefined;
    },
    'intraStateData.identifier': function () {
      this.selected_carrier = undefined;
    },
    selectedCarrierType: function (newVal) {
      if (newVal === CarrierTypes.European) {
        // Auto-select VAT option for European until we choose to support more Euro identifier options
        this.onSelectEuropeanIdentifierType(this.europeanIdentifierTypes?.[0]);
      }
    },
  },
  created: function () {
    this.isLoading = true;
    this.loadIsTypes();
    this.isLoading = false;
  },
  methods: {
    loadIsTypes() {
      /*const identifierResponse = this.$store.dispatch('identifiers/getIstypes');

    if (![200].includes(identifierResponse.status)) {
     return;
    }
    */

      // load istypes
      // const non_urs_instrastate = identifierResponse.data.non_urs_instrastate;

      this.instraStateStates = Object.entries(this.non_urs_instrastate).map(
        ([key, value]) => ({
          id: key,
          label: value,
        })
      );
      this.intraStateData.selectedState = this.instraStateStates[0].id;

      const entities = Object.entries(this.canadian_entities).map(
        ([key, value]) => ({ key, value })
      );

      this.canadianAuthorities.forEach((authority) => {
        const matchEntities = entities.filter((entity) =>
          entity.key.startsWith(authority.id)
        );
        authority.entities = matchEntities.map((entity) => ({
          id: entity.key,
          label: entity.value.split('-')[1],
          format: this.entities_formatting[entity.key]?.format,
        }));

        if (authority.entities.length === 1) {
          authority.selectedEntity = authority.entities[0];
        }
      });

      // this.canadianData.selectedAuthority = this.canadianAuthorities[0];

      this.europeanCountries = Object.entries(this.euro_vat_entities).map(
        ([key, value]) => ({
          id: key,
          label: value,
          format: this.euro_vat_entities_formatting?.[key]?.format,
          format_placeholder:
            this.euro_vat_entities_formatting?.[key]?.format_placeholder,
        })
      );
    },
    getButtonText: function () {
      if (this.selected_carrier) {
        return 'Continue';
      }
      if (this.currentStep === CarrierTypeStep.CarrierName) {
        return 'Continue';
      }

      return 'Search';
    },
    onSelectCanadianEntity: function (option) {
      this.canadianData.selectedAuthority.selectedEntity = option;
      this.selected_carrier = undefined;
    },
    onSelectCanadianAuthority: function (option) {
      this.canadianData.selectedAuthority = option;
      if (this.canadianData?.selectedAuthority?.entities?.length > 1) {
        this.canadianData.selectedAuthority.selectedEntity = undefined;
      }
      this.selected_carrier = undefined;
    },
    onCanadianTypeSelected: function (option) {
      this.canadianData.identifierType = option?.id;
      this.selected_carrier = undefined;
    },
    onSelectEuropeanIdentifierType: function (option) {
      this.europeanData.selectedIdentifierType = option;
      this.selected_carrier = undefined;
    },
    onSelectEuropeanCountry: function (option) {
      this.europeanData.selectedCountry = option;
      this.selected_carrier = undefined;
    },
    onEuropeanTypeSelected: function (option) {
      this.europeanData.identifierType = option?.id;
      this.selected_carrier = undefined;
    },
    onSelectIntraStateState: function (state) {
      this.intraStateData.selectedState = state?.id;
      this.selected_carrier = undefined;
    },
    onTypeSelected: function (type) {
      this.selectedCarrierType = type?.id;
      this.selected_carrier = undefined;
    },
    handleLegalnameUpdate: function (e) {
      this.legalName = e.target.value;
    },
    handleDbaUpdate: function (e) {
      this.dbaName = e.target.value;
    },
    isNamesContinueEnabled: function () {
      return this.legalName;
    },
    isValidIdentifierIntraState(id) {
      if (!id) {
        return false;
      }

      const numberOfHyphens = (id.match(/-/g) || []).length;
      if (numberOfHyphens > 1) {
        return false;
      }

      const numericPart = id.replace(/-/g, '');
      return /^[0-9]+$/.test(numericPart);
    },
    isEnabledForCanada() {
      if (!this.canadianData?.selectedAuthority?.selectedEntity) {
        return false;
      }

      if (!this.isValidIdentifierCanada()) {
        return false;
      }
      return true;
    },
    isValidIdentifierCanada() {
      const entity = this.canadianData?.selectedAuthority?.selectedEntity;
      if (!entity) {
        return false;
      }
      const formatting = this.entities_formatting?.[entity?.id];
      if (formatting && formatting?.digits) {
        const identifierDigits = this.canadianData?.identifier?.replace(
          /-/g,
          ''
        );
        if (typeof formatting?.digits === 'function') {
          return formatting.digits(identifierDigits?.length);
        }
        return identifierDigits?.length === formatting?.digits;
      }
      return true;
    },
    isEnabledForEurope() {
      if (!this.europeanData?.selectedCountry) {
        return false;
      }

      if (!this.isValidIdentifierEurope()) {
        return false;
      }
      return true;
    },
    isValidIdentifierEurope() {
      const country = this.europeanData?.selectedCountry;
      if (!country) {
        return false;
      }
      const formatting = this.euro_vat_entities_formatting?.[country?.id];
      if (formatting && formatting?.digits) {
        const identifierDigits = this.europeanData?.identifier?.replace(
          /[- ]/g,
          ''
        );
        if (typeof formatting?.digits === 'function') {
          return formatting.digits(identifierDigits?.length);
        }
        return identifierDigits?.length === formatting?.digits;
      }
      return true;
    },
    isEnabledForIntraState() {
      return (
        !!this.intraStateData?.selectedState &&
        this.isValidIdentifierIntraState(this.intraStateData?.identifier)
      );
    },
    isContinueEnabled: function () {
      if (this.selectedCarrierType === CarrierTypes.Mexican) {
        if (this.mexicanData.rfc?.toString()?.length >= 12) {
          return true;
        }
      }

      if (this.currentStep === CarrierTypeStep.CarrierType) {
        if (this.selected_carrier) {
          return true;
        }
        if (this.selectedCarrierType === CarrierTypes.Canadian) {
          return this.isEnabledForCanada();
        }
        if (this.selectedCarrierType === CarrierTypes.European) {
          return this.isEnabledForEurope();
        }
        return this.isEnabledForIntraState();
      }

      if (this.currentStep === CarrierTypeStep.CarrierName) {
        return this.isNamesContinueEnabled();
      }

      return true;
    },
    getIdentifier() {
      let identifierData = {};

      if (this.selectedCarrierType === CarrierTypes.Canadian) {
        let value = this.canadianData?.identifier;
        if (this.canadianData?.selectedAuthority?.showRegional) {
          value = `${this.canadianData?.identifierType}-${value}`;
        }
        identifierData = {
          value,
          is_type: this.canadianData?.selectedAuthority?.selectedEntity?.id,
        };
      }

      if (this.selectedCarrierType === CarrierTypes.IntraState) {
        identifierData = {
          value: this.intraStateData?.identifier,
          is_type: this.intraStateData?.selectedState,
        };
      }

      if (this.selectedCarrierType === CarrierTypes.Mexican) {
        identifierData = {
          value: this.mexicanData?.rfc,
          is_type: this.selectedCarrierType,
        };
      }

      if (this.selectedCarrierType === CarrierTypes.European) {
        identifierData = {
          value: this.europeanData?.identifier,
          is_type: this.europeanData?.selectedCountry?.id,
        };
      }

      return identifierData;
    },
    goToLogin() {
      this.$router.push({
        name: 'CreateAccountOrLogin',
      });
    },
    getLowercaseIsoCorrect(identifier_is_type) {
      // This assumes that the last 2 letters of the identifier_is_type are the ISO 3166-1 alpha-2 code for the country (or mapped within this.iso_correct)
      let abbv = identifier_is_type?.toLowerCase()?.slice(-2);
      if (!abbv) return;
      if (this.iso_correct?.[abbv]?.length > 0) {
        return this.iso_correct[abbv];
      }
      return abbv;
    },
    async handleCarrierTypeContinue() {
      if (this.selected_carrier) {
        this.goToLogin();
        return;
      }

      this.$store.commit('identityVerification/setRedirectAfterIDV', {
        name: 'CompanyDetails',
        path: '/company-details',
      });

      const identifier = this.getIdentifier();

      if (this.selectedCarrierType === CarrierTypes.Canadian) {
        localStorage.setItem('identifier', this.getIdentifier().is_type);
        localStorage.setItem('country_iso2', 'ca');
        this.$store.commit('users/setPreferredCountry', 'ca');
      }

      if (this.selectedCarrierType === CarrierTypes.Mexican) {
        localStorage.setItem('identifier-mx', true);
        localStorage.setItem('country_iso2', 'mx');
        this.$store.commit('users/setPreferredCountry', 'mx');
      }

      if (this.selectedCarrierType === CarrierTypes.European) {
        localStorage.setItem('identifier-eu', true);
        const prefCountry = this.getLowercaseIsoCorrect(identifier?.is_type);
        localStorage.setItem('country_iso2', prefCountry);
        this.$store.commit('users/setPreferredCountry', prefCountry);
      }

      this.isSearching = true;
      const res = await this.$store.dispatch(
        'carriers/getCarriersByIdentifier',
        identifier
      );
      this.isSearching = false;
      if ([200, 201].includes(res?.status)) {
        if (res?.data) {
          this.selected_carrier = res?.data;
        }
      } else if (res?.status !== 404) {
        toastResponse(this, res, null);
      } else {
        // the carrier doesnt exist yet
        this.currentStep = CarrierTypeStep.CarrierName;
      }
    },
    async handleContinue() {
      if (!this.isContinueEnabled() || this.isSearching) {
        return;
      }

      if (this.currentStep === CarrierTypeStep.CarrierType) {
        this.handleCarrierTypeContinue();
        return;
      }

      if (this.currentStep === CarrierTypeStep.CarrierName) {
        // manual carrier
        this.$store.commit('updateSignupField', {
          name: 'manualCarrier',
          value: {
            legalName: this.legalName,
            dbaName: this.dbaName,
            identifierData: this.getIdentifier(),
          },
        });
        this.$router.push({ name: 'CreateAccountOrLogin' });
        return;
      }
    },
  },
};
</script>
<style scoped>
.gray-10::placeholder {
  color: rgb(157, 163, 174);
}
</style>
